import { takeLatest } from 'redux-saga/effects';
import { delayInputAuctionBet } from './delayInputAuctionBet';
import { INPUT_AUCTION_BET } from '../../reducers';

export function* auctionSagas() {
  yield takeLatest([INPUT_AUCTION_BET], delayInputAuctionBet);
}
